export const basePageTitle = 'dan hemerlein'
export const basePageDescription = "dan hemerlein's personal website"
